import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = ["innerHTML"];
const _hoisted_2 = {
    key: 0,
    class: "partner-list"
};
import { FilledButton, Modal, ModalFooter, RadioButton } from '@/user/components/common';
import { computed, ref, watch } from 'vue';
import { I18nInfo } from '@/user/models';
import store from '@/user/store';
export default /*@__PURE__*/ _defineComponent({
    __name: 'PartnerAlertModal',
    props: {
        modelValue: { type: Boolean },
        onConfirm: { type: Function },
        partnerOrgs: {}
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const t = new I18nInfo('eduCenter');
        const t_common = new I18nInfo('common');
        const selectedPartner = ref(null);
        const isOpen = computed({
            get: () => props.modelValue,
            set: (value) => emit('update:modelValue', value),
        });
        watch(() => props.modelValue, (newValue) => {
            if (newValue) {
                selectedPartner.value = null;
            }
        });
        function handleRadioChange(partner) {
            selectedPartner.value = partner;
        }
        function handleConfirm() {
            isOpen.value = false;
            if (!selectedPartner.value)
                return;
            if (selectedPartner.value.partner === false) {
                store.dispatch('AlertStore/showAlertModal', {
                    message: t.translate('attend.partnerDialog.notFoundPartner'),
                });
                return;
            }
            store.commit('SecurityStore/selectPartnerId', selectedPartner.value.id);
            props.onConfirm();
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Modal), {
                size: "small",
                title: _unref(t_common).translate('modal.noti'),
                modelValue: isOpen.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((isOpen).value = $event)),
                "vertical-align": _ctx.center
            }, {
                content: _withCtx(() => [
                    _createElementVNode("p", {
                        innerHTML: _unref(t).translate('attend.partnerDialog.description')
                    }, null, 8, _hoisted_1),
                    _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
                    (props.partnerOrgs && props.partnerOrgs.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.partnerOrgs, (partner, index) => {
                                return (_openBlock(), _createBlock(_unref(RadioButton), {
                                    key: `partner-${index}`,
                                    id: `partner-radio-${index}`,
                                    name: "partner-group",
                                    label: partner.name,
                                    value: partner,
                                    checked: selectedPartner.value?.id === partner.id,
                                    onChange: () => handleRadioChange(partner)
                                }, null, 8, ["id", "label", "value", "checked", "onChange"]));
                            }), 128))
                        ]))
                        : _createCommentVNode("", true)
                ]),
                default: _withCtx(() => [
                    _createVNode(_unref(ModalFooter), null, {
                        default: _withCtx(() => [
                            _createVNode(_unref(FilledButton), {
                                class: "desktop:w-auto w-full",
                                color: "blue",
                                "desktop-size": "large",
                                "mobile-size": "medium",
                                onClick: handleConfirm
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t_common).translate('button.confirm')), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }, 8, ["title", "modelValue", "vertical-align"]));
        };
    }
});
